import React from "react";
import { Button, Form, ListGroup, Modal } from "react-bootstrap";

const SetStatus = ({ Show, Hide, Title }) => {
  return (
    <>
      <Modal show={Show} onHide={Hide}>
        <Modal.Header closeButton>
          <Modal.Title
            className="fw-bold hstack gap-2"
            style={{ fontSize: 15 }}
          >
            <span>{Title}</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="section-title d-block">
            <p className="fw-bold mb-1">For Workbrodge</p>
            <ListGroup>
                <ListGroup.Item action style={{fontSize: 12}}>In a meeting - 1 Hour</ListGroup.Item>
                <ListGroup.Item action style={{fontSize: 12}}>Commuting - 30 minutes</ListGroup.Item>
                <ListGroup.Item action style={{fontSize: 12}}>Out sick - Today</ListGroup.Item>
                <ListGroup.Item action style={{fontSize: 12}}>Vacationing - Don’t clear</ListGroup.Item>
                <ListGroup.Item action style={{fontSize: 12}}>Working remotely - Today</ListGroup.Item>
            </ListGroup>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="text-end">
          <Button
            className="py-1 px-3 rounded-1"
            style={{ fontSize: 13 }}
            variant="outline-primary"
            onClick={Hide}
          >
            Cancel
          </Button>
          <Button
            className="py-1 px-3 rounded-1"
            style={{ fontSize: 13 }}
            variant="primary"
          >
            Save Status
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SetStatus;
